import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

const selectSettings = (state: RootState) => state.video.settings;

// Этот селектор получает те зависимости, при изменении которых можно обновить параметры плеера при помощи postMessage
export const selectPlayerSoftReloadDeps = createSelector([selectSettings], (s) => ({
  ...s.controls,

  blockBackwardSeek: s.player.blockBackwardSeek,
  hideIfEnded: s.player.hideIfEnded,
  togglePlayOnClick: s.player.togglePlayOnClick,
  togglePlayAnimation: s.player.togglePlayAnimation,
  doubleTapToFullscreen: s.player.doubleTapToFullscreen,
  doubleTapToExitFullscreen: s.player.doubleTapToExitFullscreen,
  escToExitFullscreen: s.player.escToExitFullscreen,
  playPauseAnimation: s.player.playPauseAnimation,
  allowPause: s.player.allowPause,
  tapToFullscreen: s.player.tapToFullscreen,
  fontFamily: s.player.fontFamily,

  customFormTime: s.form.customTime,
  formTime: s.form.time,

  ctaSize: s.cta.size,
  ctaTextColor: s.cta.textColor,
  ctaBgColor: s.cta.bgColor,
  ctaText: s.cta.text,
  ctaAddCtaLink: s.cta.addLink,
  ctaLink: s.cta.link,
  ctaInteractionMode: s.cta.interactionMode,
  ctaMergedPlacement: s.cta.mergedPlacement,
  ctaPlacement: s.cta.placement,
  ctaPauseOnClick: s.cta.pauseOnClick,

  playbackSize: s.playback.size,
  playbackText: s.playback.text,
  playbackTextColor: s.playback.textColor,
  playbackBgColor: s.playback.bgColor,
  playbackPlacement: s.playback.placement,
}));
